import React from "react";
import { LoadingButton } from "@mui/lab";

const ButtonUI = ({
  type,
  formButton = true,
  loading,
  variant,
  buttonText,
  disabled,
  style,
  sx,
  autoFocus,
  handleSubmit,
  onFormSubmit,
  onClickFunc,
}) => {
  return (
    <LoadingButton
      type={type}
      loading={loading}
      variant={variant}
      style={style}
      sx={{ textTransform: "none", ...sx }}
      disabled={disabled}
      autoFocus={autoFocus}
      onClick={
        formButton && handleSubmit && onFormSubmit
          ? handleSubmit(onFormSubmit)
          : onClickFunc
      }
    >
      {buttonText}
    </LoadingButton>
  );
};

export default ButtonUI;
